import { useTranslation } from "react-i18next";
import { Box, Grid, Typography } from "@mui/material";
import { AddEmissionContext } from "../../../../../contexts/AddEmissionContext";
import InfoPopper from "../../../../../components/popper/InfoPopper";
import { useEffect } from "react";
import AddEmissionSectionOne from "./StepTwoSectionOne";
import { DROPDOWN_EMISSION_GROUP } from "../../../../../components/emission/emission-components";
import AddEmissionSectionTwo from "./StepTwoSectionTwo";
import { FormProvider } from "react-hook-form";
import { common, input, overview } from "../../../../../i18n";

// Import ไฟล์ที่ยังต้องแยกไว้ (กลุ่ม Complex)
import AddPurchases from "./emission-group/AddPurchases";
import AddOutsourcingTransport from "./emission-group/AddOutsourcingTransport";
import AddWastewater from "./emission-group/AddWastewater";
import AddEmployeeCommuting from "./emission-group/AddEmployeeCommuting";
import AddSepticTank from "./emission-group/AddSepticTank";
import AddOutsourcingWasteDisposal from "./emission-group/AddOutsourcingWasteDisposal";
import AddBusinessTravel from "./emission-group/AddBusinessTravel";
import SimpleAmountInput from "./emission-group/SimpleAmountInput";

const AddEmissionStepTwo = () => {
  const { t } = useTranslation([common, input, overview], {
    nsMode: "fallback",
  });

  const { refreshEmissionFactors, stepTwoForm, stepOneForm } =
    AddEmissionContext();

  const buildExtraSection = () => {
    const currentGroup: string = stepOneForm.getValues("emissionGroup") ?? "";

    // ✅ แยก Logic: ถ้าเป็นกลุ่มที่มี Logic พิเศษให้ใช้ไฟล์แยกเดิม
    switch (currentGroup) {
      case "Purchases":
        return <AddPurchases />;
      case "Outsourcing Transport":
        return <AddOutsourcingTransport />;
      case "Wastewater":
        return <AddWastewater />;
      case "Employee Commuting":
        return <AddEmployeeCommuting />;
      case "Septic Tank":
        return <AddSepticTank />;
      case "Waste Disposal":
        return <AddOutsourcingWasteDisposal />;
      case "Business Travel":
        return <AddBusinessTravel />;
      default:
        // ✅ ถ้าไม่ใช่กลุ่มข้างบน ให้วิ่งไปใช้ตัว Dynamic ที่เรายุบรวมไว้
        return (
          <SimpleAmountInput activityType={currentGroup.replaceAll(" ", "")} />
        );
    }
  };

  useEffect(() => {
    refreshEmissionFactors();
    const forceScrollToTop = () => {
      const scrollContainers = document.querySelectorAll(
        ".MuiDialogContent-root, .MuiDialog-paper, .MuiDialog-paperScrollPaper",
      );
      scrollContainers.forEach((el) => {
        el.scrollTop = 0;
      });
    };
    forceScrollToTop();
    setTimeout(forceScrollToTop, 50);
    setTimeout(forceScrollToTop, 150);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        position: "relative",
      }}
    >
      <input
        autoFocus
        aria-hidden="true"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: 0,
          height: 0,
          opacity: 0,
          border: "none",
          padding: 0,
          margin: 0,
        }}
      />
      <Typography variant="h2" color={"var(--dark)"} sx={{ marginTop: "8px" }}>
        {(() => {
          const group = DROPDOWN_EMISSION_GROUP.find(
            (i) => i.emissionGroup === stepOneForm.getValues("emissionGroup"),
          );
          return (
            <>
              {t(group?.groupEn ?? "")}
              <InfoPopper text={t(group?.description?.toString() ?? "")} />
            </>
          );
        })()}
      </Typography>
      <Grid container columnSpacing={"20px"} rowGap={"20px"}>
        <AddEmissionSectionOne />
        <FormProvider {...stepTwoForm}>{buildExtraSection()}</FormProvider>
        <AddEmissionSectionTwo />
      </Grid>
    </Box>
  );
};

export default AddEmissionStepTwo;
